import { apiv1 as api } from '@/adapters';
import type { InvocationResult } from '@/types/core/invocation-result';
import type { UUID } from '@/utils/uuid';

export const invocationResultService = {
  /** A run's stored result; null when the run stored none. */
  get: async (
    tenantId: UUID,
    connectorId: UUID,
    featureId: UUID,
    runSequence: number
  ): Promise<InvocationResult | null> => {
    const res = await api.getConnectorInvocationResult(
      tenantId,
      connectorId,
      featureId,
      runSequence
    );
    if (res.status === 404) return null;
    if (!res.ok) {
      throw new Error(
        res.error?.message ??
          `Failed to load the run result (${String(res.status)})`
      );
    }
    return {
      result: res.data?.result ?? null,
      sensitiveContentId: res.data?.sensitive_content_id ?? '',
      templateName: res.data?.template_name ?? '',
      expiresAt: res.data?.expires_at ?? '',
    };
  },
};
